import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-landscape",
  "use": "icon-landscape-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-landscape\"><path d=\"M512 64.5C264.9 64.5 64.5 264.9 64.5 512S264.8 959.5 512 959.5 959.5 759.1 959.5 512 759.1 64.5 512 64.5z m255.5 632h-511v-369h510.9l0.1 369z\" fill=\"#000000\" p-id=\"4552\" /><path d=\"M331.6 400.8h360.8v222.4H331.6z\" fill=\"#000000\" p-id=\"4553\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol